module.exports = __webpack_public_path__ + "img/esg-1-icon-1.0b7e410f.svg";